<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a>THIS BOOK IS DEDICATED TO SIR FRANK WHITTLE,<br/>HANS VON OHAIN, ANSELM FRANZ,<br/>AND NATHAN PRICE—ALL GIANTS OF THE JET AGE.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3f1169de